import { Box, Center, Collapse, Flex, Text, VStack } from '@chakra-ui/react'
import { useArrayFromRecord } from '@hb/react'
import { UploadProgress } from '@hb/shared'
import { useMemo } from 'react'
import { AnimatedLoadingBar } from '../../shared/AnimatedLoadingBar'

export const UploadProgressView = ({
  uploads,
}: {
  uploads?: Record<string, UploadProgress> | null
}) => {
  const uploadArr = useArrayFromRecord(uploads ?? {})
  return (
    <Collapse style={{ width: '100%' }} in={!!uploadArr.length}>
      <VStack
        borderTop="1px solid #cdcdcd"
        borderBottom="1px solid #cdcdcd"
        py={1}
        spacing={0}
        w="100%">
        {uploadArr.map(({ id, progress, label, index }) => (
          <Flex key={id} w="100%" px={2} py={1}>
            <Center
              overflow="hidden"
              borderRadius="full"
              position="relative"
              bg="gray.300"
              w="100%">
              <AnimatedLoadingBar progress={progress} />
              <Text
                textShadow="1px 1px 3px #00000077"
                fontFamily="Open Sans"
                zIndex={2}
                fontSize="sm"
                maxW="100%"
                minW="0"
                isTruncated
                color="white"
                position="absolute">
                {label}
                {index !== undefined ? ` ${index + 1}` : ''}
              </Text>
            </Center>
          </Flex>
        ))}
      </VStack>
    </Collapse>
  )
}

export const UploadProgressOverlay = ({
  uploads,
}: {
  uploads?: Record<string, UploadProgress> | null
}) => {
  const hasUploads = useMemo(
    () => Object.values(uploads ?? {}).some(u => u.progress !== 100),
    [uploads],
  )

  return (
    <Box
      w="100%"
      position="absolute"
      pointerEvents={hasUploads ? 'auto' : 'none'}
      opacity={hasUploads ? 1 : 0}
      bottom={0}
      left={0}
      p={2}>
      <Box w="100%" bg="whiteAlpha.800" borderRadius={8} p={2}>
        <UploadProgressView uploads={uploads} />
      </Box>
    </Box>
  )
}
